
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppConfigService } from '../services/app-config.service';
import { AuthService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
    constructor(private router: Router,
        private authService: AuthService,
        public appConfig: AppConfigService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authService.currentUserValue;
        // console.log('canActivate=>Entering', typeof currentUser, currentUser, route);
        if (currentUser) {
            // console.log('canActivate=>currentUser, route', currentUser, route);

            if (route.data.roles && !route.data.roles.some(r => currentUser.customer.roles.includes(r))) {
                // role not authorised so redirect to home page
                // console.log('canActivate=>Rejected route', route);

                this.router.navigate([this.appConfig.HomeUrl]);
                return false;
            }

            return true;
        }
        this.router.navigate([this.appConfig.LoginUrl], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
